import { handleTrack } from '../../../utils/tracker';
import { If } from '../../Atoms/Conditionals';
import { Heading, HeadingType } from '../../Typography';
import { KnowMore } from '../buttons/know-more';

interface CardsTaxesProps {
  cardData: {
    label: string;
    description: string;
    link: string;
  };
  knowMore?: boolean;
}

const CardsGuides = ({
  cardData,
  knowMore = true,
}: CardsTaxesProps): JSX.Element => {
  const { label, description, link } = cardData;
  const clickHandler = (urlSlug: string) => {
    window.open(urlSlug, '_blank', 'noopener,noreferrer');
  };
  return (
    <div
      onClick={(e) => {
        clickHandler(link);
        handleTrack({
          label: 'inpage_income_tax_efiling_guides',
          obj: e.target,
        });
      }}
    >
      <div className="m-3 sm:m-0 bg-white h-[310px] p-6 flex flex-col justify-between rounded-md shadow-xl sm:shadow-sm sm:h-[234px] sm:mb-5">
        <div>
          <Heading
            content={label}
            variant={HeadingType.h5}
            className="text-s-24 mb-4 sm:text-s-20"
          />
          <p className="text-base">{description}</p>
        </div>
        <If condition={knowMore}>
          <KnowMore
            href={link}
            funnelMetricLabel="guide_cards"
            className="ml-0"
          />
        </If>
      </div>
    </div>
  );
};

export { CardsGuides };
